import styled from 'styled-components';

import { PaginationButtons } from '../../../display/tables/components/PaginationButtons';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const Container = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spaces.m}rem;
    justify-content: center;
  }
`;

export const MainButtonStyled = styled(MainButton)`
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

export const CloseButton = styled(MainButton)`
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    order: 2;
  }
`;

export const PaginationButtonsStyled = styled(PaginationButtons)`
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    order: 1;
    justify-content: center;
    align-items: center;
  }
`;
